<p>view-component works!</p>
